import styled from "@emotion/styled";

const StyledZoomImg = styled.img`
  height: 32px;
`;

export default StyledZoomImg;
